module.exports = __webpack_public_path__ + "static/media/our-story.c6207c24.jpg";